/**
 * Lock Scrollbar
 *
 * Description: given an action of 'true - add' or 'false - remove' the lockScrollbar
 * function sets a scroll lock to the page or removes it.
 *
 * @param {*} action 'true' or 'false'
 */
 const lockScrollbar = (action : boolean) => {
  const htmlObject = document.querySelector('html');

  if (action) {
      // When the modal is shown, we want a fixed body
      const scrollDistance = htmlObject?.scrollTop ?? 0;
      document.body.style.top = `${scrollDistance * -1}px`;
      //document.body.style.position = 'fixed';
      document.body.style.overflow = 'hidden';
  } else {
      // When the modal is hidden...
      const scrollDistance = document.body.style.top;
      document.body.style.top = '';
      document.body.style.position = '';
      document.body.style.overflow = '';
      scrollDistance && window.scrollTo(0, parseInt(scrollDistance.replace('-', '').replace('px', '')));
  }
};

export default lockScrollbar;